module.exports = __webpack_public_path__ + "img/content_1.101b07b8.png";